module.exports = __webpack_public_path__ + "static/media/pfp.20662210.jpg";